<template>
  <div>
    <i :class="['pi pi-ellipsis-h', $style.icon]" @click="handleMeatballClick" />
    <Popover ref="dropdownRef">
      <div v-for="option in dropdownOptions" :key="option.text" :class="$style.tooltipWrapper">
        <div :class="[$style.dropdownListItem, { [$style.disabledListItem]: option.disable }]" @click="option.callback">
          <VdIcon store="fas" :name="option.icon" size="large" color="#BCBEC1" />
          <span :class="$style.listItemText">{{ option.text }}</span>
        </div>
      </div>
    </Popover>
  </div>
</template>

<script setup>
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import Popover from "primevue/popover";
import { useConfirm } from "primevue/useconfirm";
import { ref } from "vue";

const emit = defineEmits(["set-shop-as-default", "delete-shop", "duplicate-shop", "edit-shop"]);
const props = defineProps({
  canUserEdit: {
    type: Boolean,
    default: false,
  },
  isShopDefault: {
    type: Boolean,
    default: false,
  },
});

const confirm = useConfirm();

const notWipText = "This version is not WIP, you cannot edit or delete this shop item";

const dropdownRef = ref();

const handleMeatballClick = (event) => {
  event.stopPropagation();
  dropdownRef.value.toggle(event);
};

const handleMenuOptionEvent = (event, eventToEmit = null) => {
  if (eventToEmit) {
    emit(eventToEmit);
  }
  dropdownRef.value.toggle(event);
};

const dropdownOptions = ref([
  {
    text: "Set as default",
    icon: "fa-star",
    callback: (event) => {
      confirm.require({
        message: `The default shop for all users without a segment-specific shop will now be set to this shop!`,
        header: "Confirmation",
        rejectClass: "p-button-secondary p-button-outlined",
        acceptClass: "p-button-primary",
        acceptIcon: "pi pi-star",
        rejectLabel: "Cancel",
        acceptLabel: "Set as default",
        accept: () => {
          handleMenuOptionEvent(event, "set-shop-as-default");
        },
        reject: () => {
          handleMenuOptionEvent(event);
        },
      });
    },
    disable: props.isShopDefault,
    tooltipContent: notWipText,
  },
  {
    text: "Duplicate",
    icon: "fa-copy",
    callback: (event) => {
      handleMenuOptionEvent(event, "duplicate-shop");
    },
    disable: !props.canUserEdit,
  },
  {
    text: "Delete",
    icon: "fa-trash",
    callback: (event) => {
      confirm.require({
        message: `You are about to delete this shop. This action cannot be undone`,
        header: "Confirmation",
        rejectClass: "p-button-secondary p-button-outlined",
        acceptClass: "p-button-primary",
        acceptIcon: "pi pi-trash",
        rejectLabel: "Cancel",
        acceptLabel: "Delete shop",
        accept: () => {
          handleMenuOptionEvent(event, "delete-shop");
        },
        reject: () => {
          handleMenuOptionEvent(event);
        },
      });
    },
    disable: props.isShopDefault || !props.canUserEdit,
    tooltipContent: notWipText,
  },
  {
    text: "Edit",
    icon: "fa-edit",
    callback: (event) => {
      handleMenuOptionEvent(event, "edit-shop");
    },
    disable: !props.canUserEdit,
  },
]);
</script>

<style module>
.dropdownListItem {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  width: 240px;
  padding: 8px 8px;

  &:hover {
    background-color: var(--vd-color-neutral-light-10);
    cursor: pointer;
  }
}

.listItemText {
  font-size: 14px;
  color: var(--vd-color-text-light-2);
}

.disabledListItem {
  opacity: 0.5;
  pointer-events: none;
}

.tooltipWrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.icon {
  color: var(--vd-color-blue-default);
  font-weight: 900;
  font-size: 16px;
  cursor: pointer;
}
</style>
